import * as yup from "yup";
import { nameRule, emailRule, passwordRule, textRule } from "../commonRules";
import { isFreeEmailProvider } from "../../../validators/emailValidator";


export const CompanyRegistrationSchema = yup.object().shape({
    company_name: textRule("Company Name", { required: true }),
    full_name: nameRule("Full Name", { required: true }),
    email: emailRule("Email", { required: true })
        .test(
            "no-free-email",
            "Public email domains are not allowed (@gmail.com, @yahoo.com, etc)",
            (value) => !value || !isFreeEmailProvider(value)
        ),
    password: passwordRule("Password", { required: true }),
    confirm_password: yup.string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
});

export const FreelancerRegistrationSchema = yup.object().shape({
    full_name: nameRule("Full Name", { required: true }),
    email: emailRule("Email", { required: true }),
    password: passwordRule("Password", { required: true }),
    confirm_password: yup.string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
});
